import { HybridAPI, SuggestAPI, RecommendAPI, ApiConfiguration } from './apis';
import deepmerge from 'deepmerge';
const defaultConfig = {
    meta: {
        cache: {
            purgeable: false,
        },
    },
    search: {
        api: {
        // origin: 'https://snapi.kube.searchspring.io',
        },
    },
    autocomplete: {
        api: {
        // origin: 'https://snapi.kube.searchspring.io',
        },
    },
    recommend: {
        api: {
        // origin: 'https://snapi.kube.searchspring.io',
        },
    },
    finder: {
        api: {
        // origin: 'https://snapi.kube.searchspring.io',
        },
    },
    suggest: {
        api: {
        // origin: 'https://snapi.kube.searchspring.io',
        },
    },
};
export class Client {
    constructor(globals, config = {}) {
        if (!globals?.siteId) {
            throw 'no siteId specified!';
        }
        this.globals = globals;
        this.config = deepmerge(defaultConfig, config);
        this.requesters = {
            autocomplete: new HybridAPI(new ApiConfiguration({
                origin: this.config.autocomplete?.api?.origin,
                cache: this.config.autocomplete?.cache,
            })),
            meta: new HybridAPI(new ApiConfiguration({
                origin: this.config.meta?.api?.origin,
                cache: this.config.meta?.cache,
            })),
            recommend: new RecommendAPI(new ApiConfiguration({
                origin: this.config.recommend?.api?.origin,
                cache: this.config.recommend?.cache,
            })),
            search: new HybridAPI(new ApiConfiguration({
                origin: this.config.search?.api?.origin,
                cache: this.config.search?.cache,
            })),
            finder: new HybridAPI(new ApiConfiguration({
                origin: this.config.finder?.api?.origin,
                cache: this.config.finder?.cache,
            })),
            suggest: new SuggestAPI(new ApiConfiguration({
                origin: this.config.suggest?.api?.origin,
                cache: this.config.suggest?.cache,
            })),
        };
    }
    async meta(params) {
        const defaultParams = { siteId: this.globals.siteId };
        params = deepmerge(defaultParams, params || {});
        return this.requesters.meta.getMeta(params);
    }
    async autocomplete(params = {}) {
        if (!params.search?.query?.string) {
            throw 'query string parameter is required';
        }
        params = deepmerge(this.globals, params);
        return Promise.all([this.meta({ siteId: params.siteId || '' }), this.requesters.autocomplete.getAutocomplete(params)]);
    }
    async search(params = {}) {
        params = deepmerge(this.globals, params);
        return Promise.all([this.meta({ siteId: params.siteId || '' }), this.requesters.search.getSearch(params)]);
    }
    async finder(params = {}) {
        params = deepmerge(this.globals, params);
        return Promise.all([this.meta({ siteId: params.siteId || '' }), this.requesters.finder.getFinder(params)]);
    }
    async trending(params) {
        params = deepmerge({ siteId: this.globals.siteId }, params || {});
        return this.requesters.suggest.getTrending(params);
    }
    async recommend(params) {
        const { tag, ...otherParams } = params;
        if (!tag) {
            throw 'tag parameter is required';
        }
        const profileParams = {
            tag,
            siteId: params.siteId || this.globals.siteId,
        };
        if (otherParams.branch) {
            profileParams.branch = otherParams.branch;
            delete otherParams.branch;
        }
        const recommendParams = {
            tags: [tag],
            ...otherParams,
            siteId: params.siteId || this.globals.siteId,
        };
        const [profile, recommendations] = await Promise.all([
            this.requesters.recommend.getProfile(profileParams),
            this.requesters.recommend.batchRecommendations(recommendParams),
        ]);
        return {
            ...profile,
            results: recommendations[0].results,
        };
    }
}
